import {
  BrandDetail,
  ProductCategory,
  ProductsByCategory,
} from "custom-types/BrandDetail";
import { Product } from "custom-types/Product";

export const generateOrganizationSchema = (
  brand: BrandDetail,
  sortedCategories?: ProductCategory[],
  productsByCategory?: ProductsByCategory,
  countryCode?: string,
) => {
  const itemListElement = sortedCategories?.map((category) => {
    const products =
      productsByCategory &&
      productsByCategory[category.slug]?.map((product: Product) => ({
        "@type": "Product",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue:
            product.avgApprovedPublicReviewRating > 0
              ? product.avgApprovedPublicReviewRating
              : null,
          reviewCount:
            product.countApprovedPublicReviews > 0
              ? product.countApprovedPublicReviews
              : null,
        },
        brand: {
          "@type": "Brand",
          name: product.brand.name,
        },
        description: product.description,
        image: product.imageUrl,
        name: product.name,
        offers: product?.bestOfferVariant?.price
          ? {
              "@type": "Offer",
              availability: "In-Stock",
              price: product?.bestOfferVariant?.price,
              priceCurrency: countryCode === "US" ? "USD" : "CAD",
            }
          : undefined,
      }));

    return {
      "@type": "ListItem",
      itemListElement: products,
      name: "Products By Category",
    };
  });

  return {
    "@context": "https://schema.org",
    "@id": `${brand.id}`,
    "@type": "Organization",
    description: brand.description || undefined,
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      itemListElement,
      name: "Product Categories",
    },
    logo: brand.logo,
    name: brand.name,
    url: brand.informationWebsite || undefined,
  };
};
